import { createApp } from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './router';

// 공통 관리자 스타일
import '@/assets/styles/admin-common.css';

// 공통 유틸리티 함수 전역 등록
import * as utils from '@/assets/scripts/utils.js';

// 메뉴 권한 플러그인
import authPlugin from '@/plugins/authPlugin.js';

// RMS 세션(모델 ID) 상태 — 요청별 헤더 자동 주입용
import { RMS_MODEL_ID_HEADER, getCurrentRmsModelId } from '@/composables/useRmsSession.js';

// ==================== axios 전역 인터셉터 ====================
// 모든 API 요청에 사용자가 선택한 RMS 모델 ID를 X-RMS-Model-Id 헤더로 주입한다.
// 백엔드는 RmsTrService 계열에서만 이 헤더를 해석하므로 다른 API 에는 영향 없음.
// 값이 없거나 디폴트인 경우 헤더를 넣지 않아 백엔드가 application.yml 기본값을 사용하도록 한다.
axios.interceptors.request.use(
  (config) => {
    try {
      const modelId = getCurrentRmsModelId();
      if (modelId && !config.headers?.[RMS_MODEL_ID_HEADER]) {
        config.headers = config.headers || {};
        config.headers[RMS_MODEL_ID_HEADER] = modelId;
      }
    } catch (e) {
      // 초기화 이전 요청 등에서 실패해도 원 요청을 막지 않는다.
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const app = createApp(App);

// utils 함수들을 전역 속성으로 등록
app.config.globalProperties.$utils = utils;
app.config.globalProperties.$formatNumber = utils.formatNumber;
app.config.globalProperties.$formatDate = utils.formatDate;
app.config.globalProperties.$formatCurrency = utils.formatCurrency;
app.config.globalProperties.$formatPercent = utils.formatPercent;
app.config.globalProperties.$resolveContextPath = utils.resolveContextPath;
app.config.globalProperties.$fetchApi = utils.fetchApi;
app.config.globalProperties.$downloadCSV = utils.downloadCSV;
app.config.globalProperties.$showToast = utils.showToast;
app.config.globalProperties.$showApiError = utils.showApiError;

// contextPath를 전역으로 사용 가능하도록 설정
app.config.globalProperties.$contextPath = utils.resolveContextPath();

app.use(router).use(authPlugin, { router }).mount('#app');
